
        var result = require("!!../../../../node_modules/css-loader/index.js!./order-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/order-list/order-list.component.css
// module id = 622
// module chunks = 0